import React from 'react';
import { CtaButton } from './CtaButton';
import { CTA_LABEL, OFFER_ANCHOR } from '../../data/content';
interface CtaBlockProps {
  label?: string;
  note?: string;
  href?: string;
  onDark?: boolean;
}
export function CtaBlock({
  label = CTA_LABEL,
  note = 'Acceso Inmediato • Garantía de 7 Días',
  href = OFFER_ANCHOR,
  onDark = false
}: CtaBlockProps) {
  return <div className="mx-auto mt-3 max-w-md text-center" data-id="element-157" data-mp="3iiexhbnzhury">
      <CtaButton href={href} data-id="element-158" data-mp="j3tehcochg3x">{label}</CtaButton>
      {note && <p className={`mt-1 text-xs font-medium ${onDark ? 'text-white/80' : 'text-navy/70'}`} data-id="element-159" data-mp="e5i3uzq871kn">{note}</p>}
    </div>;
}